import './alert.scss';
import React, {Component} from 'react';
import {connect} from "react-redux";
import AlertReducer from "../../../reducers/AlertReducer";
import {default as _} from "../../../helpers/Translate"
import T from "../t/T";

class Alert extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showAlert: false,
            state: 'error',
            message: null,
            dismissible: true,
            persistence: false,
            closeOnClick: true,
	        readClicked: null
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.handleUpdateAlertState(prevProps, this.props);
    }

    handleUpdateAlertState(prevProps, thisProps) {
        if (prevProps.alert !== thisProps.alert) {
            this.setState({
                showAlert: thisProps.alert.show,
                state: thisProps.alert.state,
                icon: this.initIcon(thisProps.alert.state),
                message: thisProps.alert.message,
                dismissible: thisProps.alert.dismissible,
                persistence: thisProps.alert.persistence,
                closeOnClick: thisProps.alert.closeOnClick,
	            readClicked: thisProps.alert.readClicked
            }, () => {
                this.hideAlertAfterAnyTime();
            });
        }
    }


    initIcon(state) {
        switch (state) {
            case 'error':
                return 'fa-circle-xmark';
            case 'success':
                return 'fa-circle-check';
            default:
                return 'fa-circle-info';
        }
    }

    hideAlertAfterAnyTime = () => {
        if (!this.state.persistence){
            setTimeout(() => {
                this.hideAlert();
            }, 3000);
        }
    }

    hideAlert = () => {
        if (!this.state.persistence || this.state.dismissible) {
            this.setState({
                showAlert: false,
            })
        }
    }

    handleShowCloseButton = () => {
        return this.state.closeOnClick && (!this.state.persistence || this.state.dismissible)
    }

    clickHandler= () =>{
        if (this.state.closeOnClick){
            this.hideAlert();
        }
    }
	
	readButton = (func) => {
		let funcString = func?.toString()?.replaceAll(' ', '')
		if (func && typeof func === 'function' && funcString && funcString !== '()=>{}') {
			return <>
				<span className={'read_btn'} onClick={()=>this.readButtonClicked(this.state.readClicked)}>
					<T token={'confirm'} lang={this.props.language}/>
				</span>
			</>
		}
	}
	
	readButtonClicked = (callBackFn = ()=>{}) => {
		this.setState({
                showAlert: false,
        }, ()=>{callBackFn()})
	}
	
	
	render() {
		return (
			<>
			{this.state.showAlert &&
                <div className={'alert alert--' + this.state.state + ` ${_.direction()}`} onClick={this.clickHandler}>
                    <i className={`fa ${this.state.icon}`}/>
                    <span className={'alert__text'}>{this.state.message}</span>
	                {this.readButton(this.state.readClicked)}
	                {this.handleShowCloseButton() && <i className={"fa fa-times closeBtn"} onClick={this.hideAlert}/>}
                </div>
                }
            </>

        );
    }
}


const mapStateToProps = state => {
    const language = state.LangReducer.language;
    const alert = state.AlertReducer;
    return {alert, language};
};

export default connect(mapStateToProps)(Alert);